export default function NotFound() {
  return (
    <>
      404 NOT FOUND
    </>
  );
};